import(/* webpackMode: "eager" */ "/vercel/path0/apps/ensadmin/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppSidebar"] */ "/vercel/path0/apps/ensadmin/src/components/app-sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WagmiProvider"] */ "/vercel/path0/apps/ensadmin/src/components/providers/wagmi-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header","HeaderNav","HeaderBreadcrumbs","HeaderActions"] */ "/vercel/path0/apps/ensadmin/src/components/ui/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider","SidebarInset"] */ "/vercel/path0/apps/ensadmin/src/components/ui/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/apps/ensadmin/src/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.4_@opentelemetry+api@1.7.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"variable\":\"--font-inter\",\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
